import _ from 'lodash';

import createReducer from './_createReducerHelper';

export const IS_CONNECTED = 'socket/IS_CONNECTED';
export const SOCKET = 'socket/SOCKET';
export const SUBSCRIPTIONS = 'socket/SUBSCRIPTIONS';

const initialState = {
  isConnected: null,
  socket: null,
  subscriptions: [],
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [IS_CONNECTED]: (state, { payload }) => ({ ...state, isConnected: payload }),
  [SOCKET]: (state, { payload }) => ({ ...state, socket: payload }),
  [SUBSCRIPTIONS]: (state, { payload }) => {
    let subscriptions = [...state.subscriptions, payload];
    subscriptions = _.uniqWith(subscriptions, _.isEqual);
    return { ...state, subscriptions };
  },
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param isConnected
 * @return {{type, payload: *}}
 */
export const setConnected = (isConnected) => ({
  type: IS_CONNECTED,
  payload: isConnected,
});

/**
 *
 * @param socket
 * @return {{type, payload: *}}
 */
export const setSocket = (socket) => ({
  type: SOCKET,
  payload: socket,
});

/**
 *
 * @param subscription
 * @return {{type, payload: *}}
 */
export const setSubscription = (subscription) => ({
  type: SUBSCRIPTIONS,
  payload: subscription,
});

/** ********************************************
 * selectors
 ******************************************** */

export const selectIsConnected = (state) => state.socket.isConnected;

export const selectSocket = (state) => state.socket.socket;

export const selectSubscriptions = (state) => state.socket.subscriptions;
